<template>
  <div style="border-bottom: 1px solid black">
    <v-layout row wrap>
      <v-flex xs12>
        <h3 class="title px-2 py-4" style="text-decoration: underline;">Local Friend or Relative</h3>
      </v-flex>
      <v-flex xs12 md6 px-2>
        <v-text-field
          name="name"
          label="Name"
          :rules="order !== '1' ? noRules : nameRules"
          box
          v-model="name"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 px-2>
        <v-text-field
          name="relationship"
          label="Relationship to student"
          :rules="order !== '1' ? noRules : relationshipRules"
          box
          v-model="relationship"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6 px-2>
        <v-text-field
          name="phone"
          label="Phone"
          box
          mask="(###) ### - ####"
          :rules="order !== '1' ? noRules : phoneRules"
          v-model="phone"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 px-2>
        <v-radio-group
          v-model="phone_type"
          row
          :rules="order !== '1' ? noRules : validationRules"
          :class="{ 'radio-group-spacing' : $vuetify.breakpoint.smAndDown }"
        >
          <v-radio label="cell" value="cell"></v-radio>
          <v-radio label="home" value="home"></v-radio>
          <v-radio label="work" value="work"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6 px-2>
        <v-text-field
          name="alt_phone"
          label="Alternate Phone"
          box
          mask="(###) ### - ####"
          :rules="order !== '1' ? noRules : altPhoneRules"
          v-model="alt_phone"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 px-2>
        <v-radio-group
          v-model="alt_phone_type"
          row
          :class="{ 'radio-group-spacing' : $vuetify.breakpoint.smAndDown }"
        >
          <v-radio label="cell" value="cell"></v-radio>
          <v-radio label="home" value="home"></v-radio>
          <v-radio label="work" value="work"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: String
    }
  },
  data() {
    return {
      noRules: [],
      validationRules: [v => !!v || "Field is required"],
      nameRules: [v => !!v || "Emergency contact name is required"],
      relationshipRules: [v => !!v || "Relationship to student is required"],
      phoneRules: [v => !!v || "Phone is required"],
    };
  },
  computed: {
    name: {
      get() {
        return this.$store.state.registration.emergencyContacts[
          "contact_" + this.order
        ].name;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/emergencyContacts/setName", payload);
      }
    },
    relationship: {
      get() {
        return this.$store.state.registration.emergencyContacts[
          "contact_" + this.order
        ].relationship;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit(
          "registration/emergencyContacts/setRelationship",
          payload
        );
      }
    },
    phone: {
      get() {
        return this.$store.state.registration.emergencyContacts[
          "contact_" + this.order
        ].phone;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/emergencyContacts/setPhone", payload);
      }
    },
    phone_type: {
      get() {
        return this.$store.state.registration.emergencyContacts[
          "contact_" + this.order
        ].phone_type;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit(
          "registration/emergencyContacts/setPhoneType",
          payload
        );
      }
    },
    alt_phone: {
      get() {
        return this.$store.state.registration.emergencyContacts[
          "contact_" + this.order
        ].alt_phone;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit(
          "registration/emergencyContacts/setAltPhone",
          payload
        );
      }
    },
    alt_phone_type: {
      get() {
        return this.$store.state.registration.emergencyContacts[
          "contact_" + this.order
        ].alt_phone_type;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit(
          "registration/emergencyContacts/setAltPhoneType",
          payload
        );
      }
    }
  }
};
</script>

<style scoped>
.radio-group-spacing {
  margin-top: -15px;
  padding-bottom: 20px;
}
</style>
